import React, { useState, Fragment, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import './edit-extension-new.css'
import AddEdit from './add-editor/add-editor'
import FontCircles from './fontCircles'
import StyleEdit from './style-editor'
import NoteAChat from './noteAChat'
import EmojiPicker from '../EmojiPicker';
import IconClose from '../lucket/IconClose';
import { AddBucket } from '../AddBucket.cmp';
import { addChildToLucket, handleLucketDelete, updateValues } from '../slice/functions';
import { setBucketList, setSelectedTodo } from '../slice/buckets';
import ConfirmationModal from '../lucket/deleteLucketModal';
//back button shouldn't save colours.
//scrolling problem that hides input.
export const EditExtension = ({ updateBucket, buckets }) => {
  // Use Redux selectedTodo
  const dispatch = useDispatch();

  const selected = useSelector(state => state.bucketList.selectedTodo);
  const dueDate = selected ? selected.date : ""
  const [tabOpen, setTabOpen] = useState("style")
  let childTodos = buckets.filter(b => b.parentRowID === (selected && selected.rowID))

  const [titleNew, setTitle] = useState(selected && selected.name)
  const debounceTimeout = useRef();
  const [dateNew, setDate] = useState(selected && selected.date)
  const [DTDBR, setDTDBR] = useState(selected && selected.DTDBR)
  const [fontColor, setFontColor] = useState(null)
  const [fontSize, setFontSize] = useState(null)
  const [openAdd, setOpenAdd] = useState(false)
  const [newTodoTitle, setNewTodoTitle] = useState(null)
  const [openConfirmDelete, setOpenConfirmDelete] = useState(null)
  const [files, setFiles] = useState(null)

  const [selectedFileNew, setSelectedFile] = useState(null)
  const [open5, setOpen5] = useState(true)
  const [open, setOpen] = useState(true)
  const [more, setMore] = useState(false)
  const [openAbandonOrMarkComplete, setOpenAbandonOrMarkComplete] = useState(false)

  const updateTodo = async (name, v, fontStyleName) => {
    const newBucket = updateValues(selected, name, v, fontStyleName);

    dispatch(setSelectedTodo(newBucket));
    await updateBucket(newBucket, dispatch, buckets);
  };

  // Debounced update for title
  const handleTitleChange = (e) => {
    const value = e.target.value;
    setTitle(value);
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      updateTodo("name", value);
    }, 500);
  };

  const handleConfirmDelete = async () => {

    let result = await handleLucketDelete(selected)
    console.log(result, "result123")
    dispatch(setBucketList(result.data));
    setOpenConfirmDelete(false); // Close the modal

  };
  function handleComplete(open) {
    if (open) {
      return setOpenAbandonOrMarkComplete(open)
    }
    else {
      setOpenConfirmDelete(false)
    }
  }
  function onEmojiClick(emojiObject) {

    updateTodo("name", selected.name + emojiObject)
  }
  async function addChild() {
    let childLuckets = buckets.filter(b => b.parentRowID === selected.rowID);
    let result = await addChildToLucket(selected, childLuckets, buckets)
    dispatch(setBucketList(result.data));
  }


  //if(!urgency1&&selected)setUrgency1(selected.urgency)
  if (selected) {


    return (
      <div className="ee-outer">
        <div className="ee-card">
          <p>Selected Bucket Options</p>
          <div className="ee-tabs">
            <div className={tabOpen === "style" ? "ee-tab selected" : "ee-tab"} onClick={() => setTabOpen("style")}>Display</div>
            <div className={tabOpen === "status" ? "ee-tab selected" : "ee-tab"} onClick={() => setTabOpen("status")}>Status</div>
            <div className={tabOpen === "note" ? "ee-tab selected" : "ee-tab"} onClick={() => setTabOpen("note")}>Note</div>

          </div>
          <div className="ee-content">
            {tabOpen === "status" && <div>
              {open !== "openEmojiPicker" && <AddEdit selectedTodoReal={selected} updateTodo={updateTodo} titleNew={titleNew} dateNew={dateNew} DTDBR={DTDBR} setDTDBR={setDTDBR} setFontColor={x => setFontColor(x)} setFontSize={x => setFontSize(x)} setTitle={title => setTitle(title)} setDate={date => setDate(date)} savedDueDate={dueDate} savedTitle={selected.name} />}

            </div>}
            {tabOpen === "note" && (
              <Fragment>
                <NoteAChat id={selected.rowID} updateTodo={updateTodo} titleNew={titleNew} dateNew={dateNew} DTDBR={DTDBR} setDTDBR={setDTDBR} setFontColor={x => setFontColor(x)} setFontSize={x => setFontSize(x)} todo={selected} date={selected.date} setTitle={title => setTitle(title)} setDate={date => setDate(date)} savedDueDate={dueDate} savedTitle={selected.name} />
              </Fragment>
            )}
            {tabOpen === "style" && (
              <Fragment>
                <div className="ee-title-row">
                  <textarea
                    type='text'
                    className="ee-title-input"
                    value={selected && selected.name}
                    onChange={handleTitleChange}
                    placeholder="Enter bucket title..."
                  />
                  <span className="ee-emoji-btn" onClick={() => setOpen(open !== "openEmojiPicker" ? "openEmojiPicker" : null)} role="button" tabIndex={0}>😎</span>
                </div>
                {open === "openEmojiPicker" && <div className="ee-emoji-picker"><EmojiPicker onSelect={onEmojiClick} /></div>}
                <FontCircles selected={selected} updateTodo={updateTodo} />
                {/* Add more controls here as needed */}
                {open !== "openEmojiPicker" && <div className="ee-actions-row">
                  <button className="ee-action-btn ee-delete-btn" onClick={() => setOpenConfirmDelete(!openConfirmDelete)}>
                    <span role="img" aria-label="delete" style={{ marginRight: 6 }}>🗑️</span> Delete
                  </button>
                  {!selected.parentRowID && <button className="ee-action-btn ee-addchild-btn" onClick={() => { addChild() }}>
                    <span role="img" aria-label="add child" style={{ marginRight: 6 }}>➕</span> Add Child
                  </button>}
                </div>}
                {!selected.parentRowID && childTodos && childTodos.length > 0 && (
                  <div className="ee-children-section">
                    <div className="ee-children-title">Child Buckets:</div>
                    {childTodos.map(child => (
                      <div key={child.rowID} className="ee-child-item">
                        <span >{child.name}</span>
                        <div style={{ borderRadius: "50%", border: "solid 1px grey", backgroundColor: child.status, width: "20px", height: "20px", display: "inline-block" }} />
                        <div style={{ borderRadius: "50%", border: "solid 1px grey", backgroundColor: child.actionStatus, width: "20px", height: "20px", display: "inline-block" }} />
                        <div style={{ borderRadius: "50%", border: "solid 1px grey", backgroundColor: child.weekActionStatus, width: "20px", height: "20px", display: "inline-block" }} />
                        <button className="ee-child-select-btn" onClick={() => { dispatch(setSelectedTodo(child)) }}>
                          Select
                        </button>
                        <button onClick={() => handleConfirmDelete(child)}>Delete Child</button>
                      </div>
                    ))}
                  </div>
                )}
                <ConfirmationModal
                  open={openConfirmDelete}
                  onClose={() => setOpenConfirmDelete(false)}
                  onConfirm={_ => {
                    handleConfirmDelete()
                  }}
                  title="Delete Item"
                  message="Are you sure you want to delete this item? This action cannot be undone."
                  confirmText="Delete"
                  cancelText="Cancel"
                />
                {openConfirmDelete && <div
                >
                  <button onClick={_ => setOpenConfirmDelete(false)}> cancel</button>
                  <button onClick={_ => handleComplete(false)}>Abandon</button>
                  <button onClick={_ => handleComplete(true)}>Mark Complete</button>
                </div>}
              </Fragment>
            )}
          </div>
          <IconClose style={{ height: 24, width: 24 }} edit={() => dispatch(setSelectedTodo(null))} />

        </div>
      </div >
    )
  }
  else {
    return null
  }
}


